import { render, staticRenderFns } from "./ShapeAndAngle.vue?vue&type=template&id=4be7c278&scoped=true"
import script from "./ShapeAndAngle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShapeAndAngle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShapeAndAngle.vue?vue&type=style&index=0&id=4be7c278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7c278",
  null
  
)

export default component.exports